import { getLeaderboardTimeframe } from "@/sales-tools/leaderboard/api/getLeaderboardTimeframe";

import { getGamificationApiClient } from "../../home-product/api/api";

export interface PacingMetricsResponse {
    totalSessions: number;
    onTargetCount: number;
    onTargetRate: number;
    avgOverageSeconds: number;
}

export const getPacingMetrics = async (): Promise<PacingMetricsResponse> => {
    const { start, end } = getLeaderboardTimeframe();

    return await getGamificationApiClient()
        .get("v1/metrics/pacing", { retry: 0, searchParams: { start, end } })
        .json<PacingMetricsResponse>();
};
